import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Request from '~/providers/Request';
import moment from 'moment';
import AvailableDates from './AvailableDates';
import HeaderDays from './HeaderDays';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import lodash from 'lodash';
import InputMonthPicker from '~/components/Input/InputMonthPicker';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import Button from '@material-ui/core/Button';
import getDays from '~/utils/getDays';
import CircularProgress from '@material-ui/core/CircularProgress';
// import isBlank from '~/utils/isBlank';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  container: {
    maxHeight: 350,
    padding: 20,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default function NestedList() {
  const classes = useStyles();
  const [openGroups, setOpenGroups] = useState({});
  const [groups, setGroups] = useState([]);
  const [listSpecialities, setListSpecialties] = useState(false);
  const [month, setMonth ] = useState( moment().format('MM') );
  const [year, setYear ] = useState( moment().format('YYYY') );
  const [beginMonth, setBeginMonth] = useState( moment().startOf('month').format() );
  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(false);

  const toggleGroup = id => {
    setOpenGroups({
      ...openGroups,
      [id]: !openGroups[id]
    });
  };

  useEffect(() => {
    changeMonth();
  }, [beginMonth]);

  useEffect(() => {
    fetchSpecialties();
  }, [month]);

  const changeMonth = () => {
    const year = moment(beginMonth).format('YYYY');
    const month = moment(beginMonth).format('MM');
    setYear(year);
    setMonth(month);
    setDays( getDays(year, month) );
  };

  const fetchSpecialties = async () => {
    setLoading(true);
    const { data } = await Request.get(`/admin/schedules/timeline?year_month=${year}-${month}`, null, { normalizeJSON: false });
    setGroups(data);
    setLoading(false);
  };

  return (
      <List
        className={classes.root}
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              <InputMonthPicker disabled={loading} setStartDate={(date) => setBeginMonth(date)} />
              {loading ?
                <CircularProgress /> :
                <Button disabled={loading} style={{ height: 50 }} onClick={() => setListSpecialties(!listSpecialities)}>
                  {listSpecialities ? <ArrowDropUpIcon fontSize={'large'} color={'#ccc'} /> : <ArrowDropDownIcon fontSize={'large'} color={'#ccc'} />}
                </Button>
              }
            </div>
          </ListSubheader>
        }
      >
        {listSpecialities && groups && groups.map((specialty) => {
          return (
            <>
              <ListItem key={`specialty-${specialty.id}`} button onClick={() => toggleGroup(specialty.id)}>
                  <ListItemText primary={lodash.truncate(specialty.name, { length: 30 })} />
                  {openGroups[parseInt(specialty.id)] ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
                <Collapse in={openGroups[parseInt(specialty.id)]} timeout="auto" unmountOnExit>
                  <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ width: 270}}></TableCell>
                          {days && <TableCell>
                            <HeaderDays days={days} />
                            </TableCell>
                          }
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {specialty.doctors.map((doctor) => {
                          return (
                            <TableRow hover tabIndex={-1} key={`doctor-${doctor.id}`} >
                              <TableCell colSpan={1}>{doctor.name}</TableCell>
                              <TableCell colSpan={100}>
                                <AvailableDates doctor={doctor} dates={doctor.dates} specialty={specialty} />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Collapse>
            </>
          );
        })}
      </List>
  );
}
